// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"0ab37b5c","415":"6ce54f0d"}[chunkId] + ".chunk.js";
};